var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/pulsepoint_life_icon.png"),"alt":"Pulse Point HCP365"}})
}
var staticRenderFns = []

export { render, staticRenderFns }